import { Button } from "reactstrap";
import { ReviewsData } from "../../../data/pages/Blog";
import { dynamicImage, Image } from "../../../utils";
import { Clock, MessageEdit } from "iconsax-react";
import { Rating } from "react-simple-star-rating";
import { CommentTitle, LeaveCommentTitle } from "../../../constants";
import ReviewModal from "../modals/ReviewModal";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { setReviewModal } from "../../../reduxToolkit/reducers/layoutSlice";

const Comment = () => {
  const dispatch = useAppDispatch();
  return (
    <>
      <div className="detail-box review-detail">
        <div className="modal-btn-flex">
          <h3 className="car-title">{CommentTitle}</h3>
          <Button className="text-btn" color="transparent" onClick={() => dispatch(setReviewModal())}>
            <MessageEdit className="iconsax" /> {LeaveCommentTitle}
          </Button>
        </div>
        <ul className="review-main-list">
          {ReviewsData.map((review, index) => (
            <li key={index} className={`review-box ${review.isReply ? "replay-box" : ""}`}>
              <div className="review-profile">
                <Image src={dynamicImage(review.image)} alt={review.name} className="img-fluid" />
                <div className="profile-flex">
                  <div>
                    <h6>{review.name}</h6>
                    <ul className="rating">
                      <li>
                        <Rating size={20} initialValue={review.rating} />
                      </li>
                      <li>
                        <span>({review.rating})</span>
                      </li>
                    </ul>
                  </div>
                  <span>
                    <Clock className="iconsax" /> {review.timestamp}
                  </span>
                </div>
              </div>
              <p>{review.message}</p>
            </li>
          ))}
        </ul>
      </div>
      <ReviewModal />
    </>
  );
};

export default Comment;
